import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import RevitParameterTemplates from "./RevitParameterTemplates.graphql";

export default function useRevitParameterTemplates() {
    return useQuery(
        gql(RevitParameterTemplates),
    );
}
